import { useQuery } from 'react-query';
import { API_ENDPOINTS } from '../utils/api-endpoints';
import { queryFetch } from '../utils/query-fetch';
import { queryOptions } from '../utils/use-query-wrapper';

const getProductFiles = ({ id, props }: { id: string | number; props?: queryOptions }) =>
  useQuery([API_ENDPOINTS.GET_PRODUCT_FILES(id), props?.params], queryFetch, props?.options);

export default getProductFiles;
